import { API_ENDPOINTS } from "@/api/services/Settings/apiEndpoint";
import { baseApi } from "@/utils/baseApi";

export const menuApi = baseApi.injectEndpoints({


  endpoints: (builder) => ({
    fetchSettings: builder.query({
      transformResponse: (response) => response?.data,
      query: ({ referenceName }) => ({
        url: API_ENDPOINTS.MENU.FETCH_SETTINGS({ referenceName }),
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [{ type: "Menu", id: "LIST" }]
          : [{ type: "Menu", id: "LIST" }],
    }),
    addMenu: builder.mutation({
      query: ({ formData }) => ({
        url: API_ENDPOINTS.MENU.ADD_MENU(),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "Menu", id: "LIST" }],
    }),
    fetchMenu: builder.query({
      query: () => ({
        url: API_ENDPOINTS.MENU.FETCH_MENU(),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "Menu", id: "LIST" }],
    }),
    updateMenuStatus: builder.mutation({
      query: (menuId) => ({
        url: API_ENDPOINTS.MENU.UPDATE_STATUS(menuId),
        method: "PUT",
        body: menuId,
      }),
      invalidatesTags: [{ type: "Menu", id: "LIST" }],
    }),
    updateMenu: builder.mutation({
      query: ({ menuId, formData }) => ({
        url: API_ENDPOINTS.MENU.UPDATE_MENU(menuId),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "Menu", id: "LIST" }],
    }),
    deleteMenu: builder.mutation({
      query: (menuId) => ({
        url: API_ENDPOINTS.MENU.DELETE_MENU(menuId),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Menu", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchSettingsQuery,
  useAddMenuMutation,
  useFetchMenuQuery,
  useUpdateMenuStatusMutation,
  useUpdateMenuMutation,
  useDeleteMenuMutation,
} = menuApi;
